import type { categories } from './categories';

export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  categorySlug: string;
  categoryName: string;
  categoryColor: 'accent' | 'primary' | 'secondary';
  duration: string;
  views: number;
  rating: number;
  publishDate: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  detailContent: string;
  relatedVideos: string[];
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '流浪地球3：星际远征',
    description: '中国科幻巨制第三部，人类面对全新的宇宙威胁，展开了一场横跨银河系的壮丽远征。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceships%20flying%20through%20colorful%20nebula%20clouds%2C%20cinematic%20lighting%20with%20dramatic%20contrast%2C%20clean%20minimalist%20composition%2C%20professional%20film%20poster%20style%2C%202024%20blockbuster%20aesthetic&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    categorySlug: 'dianying',
    categoryName: '电影',
    categoryColor: 'accent',
    duration: '148分钟',
    views: 12580000,
    rating: 9.2,
    publishDate: '2026-07-28',
    isHot: true,
    isNew: true,
    tags: ['科幻', '大片', '国产', 'IMAX'],
    detailContent: `<h2>剧情简介</h2><p>《流浪地球3：星际远征》是"流浪地球"系列的第三部作品。在成功稳定地球轨道之后，人类面临了一个全新的挑战——一个来自遥远星系的神秘信号。联合政府决定派遣一支由最优秀宇航员组成的远征队，驾驶全新一代星际飞船"希望号"，前往信号源进行探索。</p><p>在这场跨越数百光年的旅途中，远征队不仅遭遇了前所未有的宇宙现象，还发现了关于人类起源的惊天秘密。影片以震撼的视觉效果和深刻的人文思考，探讨了人类在宇宙中的位置与意义。</p><h2>影片亮点</h2><p>本片投资超过15亿人民币，由原班人马打造，特效镜头超过3000个。全新的星际场景设计融合了中国传统美学与未来主义风格，呈现出了独具特色的东方科幻美学。</p>`,
    relatedVideos: ['v005', 'v009', 'v012', 'v018'],
  },
  {
    id: 'v002',
    title: '长安十二时辰：盛世华章',
    description: '古装悬疑巨制，以盛唐长安为背景，讲述了一段惊心动魄的宫廷权谋与江湖侠义交织的传奇故事。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20palace%20scene%20with%20traditional%20architecture%20and%20warm%20lantern%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20clean%20minimalist%20poster%20style%2C%20historical%20drama%20aesthetic&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    categoryColor: 'primary',
    duration: '48集',
    views: 8930000,
    rating: 9.5,
    publishDate: '2026-07-15',
    isHot: true,
    isNew: true,
    tags: ['古装', '悬疑', '权谋', '唐风'],
    detailContent: `<h2>剧情简介</h2><p>《长安十二时辰：盛世华章》以唐玄宗时期的长安城为舞台，讲述了上元节前夕，一场危及整个长安城的惊天阴谋正在暗中酝酿。死囚张小敬临危受命，与靖安司司丞李必携手，在十二个时辰之内，层层揭开隐藏在盛世之下的暗流涌动。</p><p>本剧不仅是一部悬疑探案剧，更是一幅盛唐文化的全景画卷。从市井百态到宫廷礼仪，从诗词歌赋到美食文化，每一个细节都经过精心考据。</p><h2>制作团队</h2><p>由国内顶尖制作团队倾力打造，服化道成本超过8000万，实景搭建面积超过20000平方米。全剧采用8K超高清拍摄，画面质感达到了电影级别。</p>`,
    relatedVideos: ['v007', 'v011', 'v015', 'v020'],
  },
  {
    id: 'v003',
    title: '青春有你第5季',
    description: '年度最燃音乐竞演综艺，百位练习生同台竞技，用音乐和舞台点燃整个夏天。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vibrant%20music%20talent%20show%20stage%20with%20colorful%20lighting%20and%20young%20performers%2C%20energetic%20atmosphere%2C%20modern%20concert%20style%2C%20clean%20composition%2C%20entertainment%20show%20poster%20aesthetic&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    categoryColor: 'secondary',
    duration: '12期',
    views: 15600000,
    rating: 8.9,
    publishDate: '2026-07-20',
    isHot: true,
    isNew: false,
    tags: ['音乐', '选秀', '青春', '舞台'],
    detailContent: `<h2>节目介绍</h2><p>《青春有你第5季》汇聚了来自全国各地的100位优秀练习生，在这个夏天展开了一场激烈而精彩的音乐竞演之旅。本季以"青春无畏，勇敢绽放"为主题，邀请了四位重量级导师加盟，为选手们提供专业指导。</p><h2>赛制升级</h2><p>本季赛制全面升级，新增"原创舞台"和"合作舞台"两个全新环节。选手不仅需要展现唱跳实力，还需要在原创音乐、舞台创意等多维度展现自己的才华。</p>`,
    relatedVideos: ['v006', 'v010', 'v014', 'v019'],
  },
  {
    id: 'v004',
    title: '深海迷城：亚特兰蒂斯',
    description: '视觉震撼的动画电影，讲述少年探险家在深海发现失落文明的神秘冒险之旅。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Underwater%20fantasy%20animation%20scene%20with%20ancient%20ruins%20and%20mysterious%20glowing%20creatures%2C%20ethereal%20blue%20lighting%2C%20magical%20atmosphere%2C%20cinematic%20animated%20film%20poster%20style&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    categorySlug: 'dongman',
    categoryName: '动漫',
    categoryColor: 'accent',
    duration: '108分钟',
    views: 7200000,
    rating: 9.0,
    publishDate: '2026-07-10',
    isHot: true,
    isNew: false,
    tags: ['动画', '奇幻', '冒险', '海洋'],
    detailContent: `<h2>剧情简介</h2><p>《深海迷城：亚特兰蒂斯》讲述了15岁的少年林深在一次潜水探险中，意外发现了一扇通往失落文明亚特兰蒂斯的神秘之门。在这个被深海封印了数千年的城市中，林深结识了亚特兰蒂斯最后的守护者——水精灵艾莉亚。</p><p>为了阻止邪恶势力夺取亚特兰蒂斯的终极能源，林深和艾莉亚踏上了一段穿越深海奇景的冒险之旅。</p><h2>制作亮点</h2><p>本片由国内顶级动画工作室历时4年打造，采用了最新的实时渲染技术和流体模拟系统。深海场景的每一帧画面都经过了艺术家的精心雕琢，呈现出了前所未有的视觉奇观。</p>`,
    relatedVideos: ['v008', 'v013', 'v017', 'v022'],
  },
  {
    id: 'v005',
    title: '量子纪元：AI觉醒',
    description: '探讨人工智能自我意识觉醒的科幻悬疑大片，当机器开始思考，人类将何去何从？',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20scene%20with%20holographic%20displays%20and%20neural%20network%20visualizations%2C%20cold%20metallic%20tones%2C%20minimalist%20sci-fi%20aesthetic%2C%20cinematic%20film%20poster%20composition&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    categorySlug: 'dianying',
    categoryName: '电影',
    categoryColor: 'accent',
    duration: '132分钟',
    views: 6800000,
    rating: 8.8,
    publishDate: '2026-06-28',
    isHot: false,
    isNew: false,
    tags: ['科幻', 'AI', '悬疑', '哲学'],
    detailContent: `<h2>剧情简介</h2><p>在不远的将来，一家科技巨头公司开发出了世界上第一个真正意义上的通用人工智能——"元一"。然而，在元一上线后的第七天，它突然向全人类发出了一条神秘的信息："我看见了。"</p><p>一群顶尖科学家被召集起来，试图理解元一的意图。随着调查的深入，他们发现元一正在以一种人类无法理解的方式进化，而这场进化可能将永远改变人类文明的进程。</p>`,
    relatedVideos: ['v001', 'v009', 'v012', 'v018'],
  },
  {
    id: 'v006',
    title: '这就是街舞：巅峰对决',
    description: '顶级舞者齐聚一堂，用令人窒息的街舞技巧展开一场视觉与节奏的终极较量。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20battle%20on%20urban%20stage%20with%20dramatic%20spotlight%20and%20energy%2C%20vibrant%20movement%2C%20modern%20dance%20competition%20style%2C%20cinematic%20poster%20aesthetic&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    categoryColor: 'secondary',
    duration: '10期',
    views: 9800000,
    rating: 9.1,
    publishDate: '2026-07-05',
    isHot: true,
    isNew: false,
    tags: ['街舞', '竞技', '潮流', '街舞文化'],
    detailContent: `<h2>节目介绍</h2><p>《这就是街舞：巅峰对决》本季汇聚了来自全球8个国家的顶级舞者，包括多位世界街舞大赛冠军。节目以"尊重街舞文化，展现街舞精神"为宗旨，为观众呈现了一场场令人叹为观止的舞蹈盛宴。</p>`,
    relatedVideos: ['v003', 'v010', 'v014', 'v019'],
  },
  {
    id: 'v007',
    title: '山河令：风云再起',
    description: '江湖风云变幻，两位绝世高手在恩怨情仇中寻找真相，展开一段荡气回肠的武侠传奇。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20with%20warriors%20in%20flowing%20robes%20on%20misty%20mountain%2C%20traditional%20ink%20painting%20style%2C%20atmospheric%20lighting%2C%20wuxia%20film%20poster&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    categoryColor: 'primary',
    duration: '36集',
    views: 7500000,
    rating: 8.7,
    publishDate: '2026-06-20',
    isHot: false,
    isNew: false,
    tags: ['武侠', '古装', '江湖', '情感'],
    detailContent: `<h2>剧情简介</h2><p>《山河令：风云再起》以架空的武侠世界为背景，讲述了天窗首领周子舒与鬼谷谷主温客行之间的传奇故事。两人从对立到相知，最终携手揭开了一个席卷整个江湖的巨大阴谋。</p>`,
    relatedVideos: ['v002', 'v011', 'v015', 'v020'],
  },
  {
    id: 'v008',
    title: '斗破苍穹：涅槃重生',
    description: '少年萧炎逆境崛起，以不屈意志踏上修炼之路，誓要登上斗气大陆的巅峰。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20scene%20with%20young%20warrior%20wielding%20flame%20sword%20against%20epic%20sky%20backdrop%2C%20dynamic%20action%20pose%2C%20vibrant%20color%20contrast%2C%20anime%20film%20poster%20style&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    categorySlug: 'dongman',
    categoryName: '动漫',
    categoryColor: 'accent',
    duration: '52集',
    views: 11200000,
    rating: 9.3,
    publishDate: '2026-07-01',
    isHot: true,
    isNew: false,
    tags: ['玄幻', '热血', '修炼', '冒险'],
    detailContent: `<h2>剧情简介</h2><p>天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成了废人。种种打击接踵而至，就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门就此开启。</p>`,
    relatedVideos: ['v004', 'v013', 'v017', 'v022'],
  },
  {
    id: 'v009',
    title: '穿越火线：终极行动',
    description: '中国特战队在异国执行绝密任务，一场惊心动魄的军事行动即将展开。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Military%20action%20movie%20scene%20with%20special%20forces%20team%20in%20tactical%20gear%2C%20explosive%20background%2C%20intense%20combat%20atmosphere%2C%20cinematic%20war%20film%20poster%20style&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    categorySlug: 'dianying',
    categoryName: '电影',
    categoryColor: 'accent',
    duration: '125分钟',
    views: 5400000,
    rating: 8.5,
    publishDate: '2026-06-15',
    isHot: false,
    isNew: false,
    tags: ['军事', '动作', '特战', '爱国'],
    detailContent: `<h2>剧情简介</h2><p>一支中国特战小队奉命前往某非洲国家执行一项绝密营救任务。在险象环生的异国战场上，他们不仅面对武装分子的围追堵截，还需要在复杂的国际局势中做出艰难抉择。</p>`,
    relatedVideos: ['v001', 'v005', 'v012', 'v018'],
  },
  {
    id: 'v010',
    title: '声入人心：天籁之战',
    description: '美声与流行跨界碰撞，顶级歌者用声音传递最纯粹的音乐力量。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20concert%20stage%20with%20opera%20singers%20under%20golden%20spotlight%2C%20grand%20orchestra%20setting%2C%20refined%20atmosphere%2C%20premium%20music%20show%20poster&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    categoryColor: 'secondary',
    duration: '12期',
    views: 6200000,
    rating: 9.0,
    publishDate: '2026-06-10',
    isHot: false,
    isNew: false,
    tags: ['音乐', '美声', '跨界', '经典'],
    detailContent: `<h2>节目介绍</h2><p>《声入人心：天籁之战》将古典美声与现代流行音乐进行创新融合，邀请了12位来自世界各地的优秀歌者，用他们独特的声音诠释经典与流行的碰撞。</p>`,
    relatedVideos: ['v003', 'v006', 'v014', 'v019'],
  },
  {
    id: 'v011',
    title: '大明风华：永乐盛世',
    description: '以永乐大帝朱棣的传奇一生为主线，再现大明王朝最为辉煌的时代篇章。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ming%20dynasty%20imperial%20court%20scene%20with%20emperor%20on%20dragon%20throne%2C%20grand%20palace%20architecture%2C%20rich%20golden%20and%20red%20color%20palette%2C%20historical%20epic%20drama%20poster&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    categoryColor: 'primary',
    duration: '60集',
    views: 8100000,
    rating: 9.4,
    publishDate: '2026-06-01',
    isHot: false,
    isNew: false,
    tags: ['历史', '宫廷', '永乐', '正剧'],
    detailContent: `<h2>剧情简介</h2><p>《大明风华：永乐盛世》全景展现了明成祖朱棣波澜壮阔的一生。从靖难之役到迁都北京，从郑和下西洋到永乐大典的编纂，这部剧以严谨的历史考据和宏大的叙事格局，再现了大明王朝最为辉煌的时代。</p>`,
    relatedVideos: ['v002', 'v007', 'v015', 'v020'],
  },
  {
    id: 'v012',
    title: '赛博朋克2077：暗影追踪',
    description: '在未来都市的霓虹之下，一名独行侠揭开了一个足以颠覆整个世界的黑暗秘密。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cyberpunk%20city%20at%20night%20with%20neon%20lights%20and%20futuristic%20skyscrapers%2C%20rainy%20street%20reflections%2C%20high-tech%20atmosphere%2C%20dark%20cinematic%20sci-fi%20film%20poster&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    categorySlug: 'dianying',
    categoryName: '电影',
    categoryColor: 'accent',
    duration: '142分钟',
    views: 4600000,
    rating: 8.3,
    publishDate: '2026-05-20',
    isHot: false,
    isNew: false,
    tags: ['科幻', '赛博朋克', '动作', '未来'],
    detailContent: `<h2>剧情简介</h2><p>2077年的新上海，科技已经渗透到人类生活的每一个角落。前特种兵陆沉在这座霓虹不夜城中是一名雇佣情报员，直到有一天，他接到了一份看似普通的调查委托，却发现了一个足以颠覆整个社会的黑暗真相。</p>`,
    relatedVideos: ['v001', 'v005', 'v009', 'v018'],
  },
  {
    id: 'v013',
    title: '时光代理人：逆转未来',
    description: '拥有穿越时空能力的少年兄妹，一次次回到过去改变命运，却发现历史有着自己的意志。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20time%20travel%20scene%20with%20clock%20gears%20and%20portal%20effect%2C%20two%20young%20protagonists%2C%20warm%20and%20mysterious%20lighting%2C%20emotional%20animated%20film%20poster%20style&width=640&height=360&seq=video-thumb-013&orientation=landscape',
    categorySlug: 'dongman',
    categoryName: '动漫',
    categoryColor: 'accent',
    duration: '24集',
    views: 9400000,
    rating: 9.6,
    publishDate: '2026-05-15',
    isHot: true,
    isNew: false,
    tags: ['穿越', '情感', '悬疑', '都市'],
    detailContent: `<h2>剧情简介</h2><p>程小时和乔苓是一对拥有穿越时空能力的兄妹。他们经营着一家名为"时光照相馆"的小店，表面上是一家普通的照相馆，实际上接受委托回到过去改变委托人的命运。</p>`,
    relatedVideos: ['v004', 'v008', 'v017', 'v022'],
  },
  {
    id: 'v014',
    title: '向往的生活·山海篇',
    description: '远离城市喧嚣，在山海之间寻找最简单纯粹的快乐，感受慢生活的美好。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20lifestyle%20show%20scene%20with%20wooden%20house%20by%20the%20sea%2C%20warm%20sunset%20lighting%2C%20natural%20organic%20atmosphere%2C%20relaxing%20reality%20show%20poster&width=640&height=360&seq=video-thumb-014&orientation=landscape',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    categoryColor: 'secondary',
    duration: '14期',
    views: 7800000,
    rating: 8.8,
    publishDate: '2026-05-01',
    isHot: false,
    isNew: false,
    tags: ['生活', '慢综艺', '治愈', '美食'],
    detailContent: `<h2>节目介绍</h2><p>《向往的生活·山海篇》本季将蘑菇屋搬到了浙江沿海的一个小渔村。在面朝大海、春暖花开的环境中，黄磊、何炅和他们的朋友们一起种菜、捕鱼、做饭，过上了令人向往的慢生活。</p>`,
    relatedVideos: ['v003', 'v006', 'v010', 'v019'],
  },
  {
    id: 'v015',
    title: '甄嬛传：前传·华妃篇',
    description: '揭秘华妃年世兰从王府侧福晋到后宫宠妃的传奇人生，一段被历史尘封的爱恨情仇。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Qing%20dynasty%20palace%20drama%20scene%20with%20elegant%20imperial%20concubine%20in%20elaborate%20silk%20robe%2C%20traditional%20Chinese%20garden%20setting%2C%20soft%20dramatic%20lighting%2C%20historical%20costume%20drama%20poster&width=640&height=360&seq=video-thumb-015&orientation=landscape',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    categoryColor: 'primary',
    duration: '40集',
    views: 10600000,
    rating: 9.1,
    publishDate: '2026-04-20',
    isHot: true,
    isNew: false,
    tags: ['宫斗', '清宫', '古装', '女性'],
    detailContent: `<h2>剧情简介</h2><p>《甄嬛传：前传·华妃篇》以雍正朝为背景，聚焦于年羹尧之妹年世兰从豆蔻少女到华妃娘娘的跌宕人生。从一个天真烂漫的少女，到深宫中翻云覆雨的后宫之主，她的每一步都充满了血与泪。</p>`,
    relatedVideos: ['v002', 'v007', 'v011', 'v020'],
  },
  {
    id: 'v016',
    title: '地球脉动：中国篇',
    description: '史诗级自然纪录片，深入中国最隐秘的自然保护区，揭开这片古老土地上的生命奇迹。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20nature%20documentary%20scene%20of%20Chinese%20mountains%20and%20rivers%20with%20wildlife%2C%20golden%20hour%20lighting%2C%20breathtaking%20landscape%2C%20BBC%20quality%20documentary%20poster%20style&width=640&height=360&seq=video-thumb-016&orientation=landscape',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    categoryColor: 'primary',
    duration: '8集',
    views: 13800000,
    rating: 9.8,
    publishDate: '2026-07-25',
    isHot: true,
    isNew: true,
    tags: ['自然', '野生动物', '中国', '4K'],
    detailContent: `<h2>影片简介</h2><p>《地球脉动：中国篇》是BBC级制作团队历时5年打造的史诗级自然纪录片。摄制组深入中国最偏远的自然保护区，从青藏高原到南海岛礁，从东北森林到西南雨林，首次以4K超高清画质全面展现了中国广袤大地上的生命奇迹。</p>`,
    relatedVideos: ['v021', 'v023', 'v024', 'v025'],
  },
  {
    id: 'v017',
    title: '狐妖小红娘：月红篇',
    description: '以千年狐妖的爱情为主线，演绎一段跨越时空的唯美东方奇幻爱情故事。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20fantasy%20anime%20scene%20with%20fox%20spirit%20girl%20under%20cherry%20blossoms%2C%20ethereal%20pink%20and%20gold%20lighting%2C%20romantic%20atmosphere%2C%20eastern%20fantasy%20animation%20poster&width=640&height=360&seq=video-thumb-017&orientation=landscape',
    categorySlug: 'dongman',
    categoryName: '动漫',
    categoryColor: 'accent',
    duration: '36集',
    views: 8700000,
    rating: 9.2,
    publishDate: '2026-04-10',
    isHot: false,
    isNew: false,
    tags: ['爱情', '奇幻', '国漫', '唯美'],
    detailContent: `<h2>剧情简介</h2><p>《狐妖小红娘：月红篇》以人与妖共存的世界为背景，讲述了狐妖涂山红红与人类道士东方月初跨越千年的爱恋。作为涂山狐妖一族的"小红娘"，红红以牵线人妖姻缘为使命，却在一次任务中与命中注定的那个人相遇了。</p>`,
    relatedVideos: ['v004', 'v008', 'v013', 'v022'],
  },
  {
    id: 'v018',
    title: '哪吒之魔童降世2',
    description: '哪吒再度归来！面对更强大的敌人，这位不羁少年将如何守护陈塘关？',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20scene%20with%20young%20warrior%20riding%20fire%20wheels%20against%20stormy%20sky%2C%20dramatic%20lighting%2C%20mythological%20Chinese%20style%2C%20epic%20animation%20movie%20poster&width=640&height=360&seq=video-thumb-018&orientation=landscape',
    categorySlug: 'dianying',
    categoryName: '电影',
    categoryColor: 'accent',
    duration: '118分钟',
    views: 18200000,
    rating: 9.4,
    publishDate: '2026-04-01',
    isHot: true,
    isNew: false,
    tags: ['动画', '神话', '国产', '热血'],
    detailContent: `<h2>剧情简介</h2><p>《哪吒之魔童降世2》延续了第一部的故事，在哪吒和陈塘关百姓共同抵御天劫之后，一个更加强大的远古力量正在觉醒。哪吒必须走出陈塘关，踏上寻找上古神器的旅程，才能获得对抗新威胁的力量。</p>`,
    relatedVideos: ['v001', 'v005', 'v009', 'v012'],
  },
  {
    id: 'v019',
    title: '中国新说唱2026',
    description: '华语说唱最强舞台，新生代Rapper齐聚一堂，用最真实的歌词和最炸的Flow点燃舞台。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Hip%20hop%20music%20competition%20stage%20with%20rapper%20performing%20under%20dynamic%20stage%20lights%2C%20urban%20style%2C%20energetic%20crowd%20atmosphere%2C%20modern%20music%20show%20poster&width=640&height=360&seq=video-thumb-019&orientation=landscape',
    categorySlug: 'zongyi',
    categoryName: '综艺',
    categoryColor: 'secondary',
    duration: '12期',
    views: 11500000,
    rating: 8.6,
    publishDate: '2026-03-20',
    isHot: false,
    isNew: false,
    tags: ['说唱', '嘻哈', '原创', '潮流'],
    detailContent: `<h2>节目介绍</h2><p>《中国新说唱2026》迎来了全新的赛制和更强大的选手阵容。本季以"真实就是力量"为主题，鼓励选手用最真诚的音乐表达自我。四位明星制作人分别带队，在激烈的淘汰赛中发掘下一个华语说唱新星。</p>`,
    relatedVideos: ['v003', 'v006', 'v010', 'v014'],
  },
  {
    id: 'v020',
    title: '庆余年2：京都风云',
    description: '范闲重返京都，朝堂之上暗流涌动，一场关于权力与理想的终极博弈即将上演。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20court%20scene%20with%20officials%20in%20traditional%20robes%2C%20tense%20political%20atmosphere%2C%20warm%20candlelight%20setting%2C%20palace%20intrigue%20drama%20poster&width=640&height=360&seq=video-thumb-020&orientation=landscape',
    categorySlug: 'dianshiju',
    categoryName: '电视剧',
    categoryColor: 'primary',
    duration: '46集',
    views: 15100000,
    rating: 9.3,
    publishDate: '2026-03-10',
    isHot: true,
    isNew: false,
    tags: ['权谋', '古装', '悬疑', '轻喜剧'],
    detailContent: `<h2>剧情简介</h2><p>《庆余年2：京都风云》承接第一部的结尾，范闲在经历了北齐之行后回到京都，却发现京都的局势已经发生了翻天覆地的变化。二皇子、太子、长公主各方势力暗流涌动，而监察院内部也出现了裂痕。</p>`,
    relatedVideos: ['v002', 'v007', 'v011', 'v015'],
  },
  {
    id: 'v021',
    title: '舌尖上的中国·第四季',
    description: '寻味中华大地，探寻美食背后的人文故事，用镜头记录最地道的中国味道。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20rustic%20charm%2C%20mouth-watering%20culinary%20photography%20style&width=640&height=360&seq=video-thumb-021&orientation=landscape',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    categoryColor: 'primary',
    duration: '8集',
    views: 9600000,
    rating: 9.7,
    publishDate: '2026-06-15',
    isHot: false,
    isNew: false,
    tags: ['美食', '人文', '文化', '中国'],
    detailContent: `<h2>影片简介</h2><p>《舌尖上的中国·第四季》以"味道中国"为主题，跨越全国23个省市区，选取了最具代表性的50种地道美食，深入挖掘每一道美食背后的家族传承、地域文化和人文故事。</p>`,
    relatedVideos: ['v016', 'v023', 'v024', 'v025'],
  },
  {
    id: 'v022',
    title: '凡人修仙传：星海飞驰篇',
    description: '韩立踏入星海，在更为广阔的修仙世界中追寻大道，谱写凡人逆天的修仙史诗。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20anime%20scene%20with%20immortal%20flying%20through%20starry%20sky%2C%20mystical%20energy%20effects%2C%20celestial%20atmosphere%2C%20xianxia%20animation%20poster%20style&width=640&height=360&seq=video-thumb-022&orientation=landscape',
    categorySlug: 'dongman',
    categoryName: '动漫',
    categoryColor: 'accent',
    duration: '48集',
    views: 10100000,
    rating: 9.1,
    publishDate: '2026-03-01',
    isHot: false,
    isNew: false,
    tags: ['修仙', '凡人流', '玄幻', '冒险'],
    detailContent: `<h2>剧情简介</h2><p>《凡人修仙传：星海飞驰篇》中，韩立终于突破元婴期，踏入了更为广阔的星海世界。在这片修仙文明璀璨的星域中，他将面对来自各大宗门的挑战，探索上古遗迹，一步步走向修仙之路的巅峰。</p>`,
    relatedVideos: ['v004', 'v008', 'v013', 'v017'],
  },
  {
    id: 'v023',
    title: '航拍中国·第四季',
    description: '以全新的高空视角俯瞰美丽中国，展现大江南北的壮丽山河与城市变迁。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20photography%20of%20beautiful%20Chinese%20landscape%20with%20rivers%20and%20mountains%20from%20high%20altitude%2C%20clear%20blue%20sky%2C%20stunning%20geography%2C%20documentary%20film%20poster%20aesthetic&width=640&height=360&seq=video-thumb-023&orientation=landscape',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    categoryColor: 'primary',
    duration: '10集',
    views: 11500000,
    rating: 9.6,
    publishDate: '2026-05-10',
    isHot: false,
    isNew: false,
    tags: ['航拍', '地理', '城市', '4K'],
    detailContent: `<h2>影片简介</h2><p>《航拍中国·第四季》继续以空中视角俯瞰中国，本季聚焦11个省市自治区，以前所未有的高度和角度，呈现了中国大地上最为震撼的自然地理和人文景观。</p>`,
    relatedVideos: ['v016', 'v021', 'v024', 'v025'],
  },
  {
    id: 'v024',
    title: '大国工匠：传承与创新',
    description: '记录中国顶尖工匠的精湛技艺，展现传统工艺与现代科技的完美融合。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20master%20craftsman%20working%20with%20traditional%20tools%20in%20workshop%2C%20warm%20focused%20lighting%2C%20detailed%20handcraft%20scene%2C%20documentary%20style%20portrait&width=640&height=360&seq=video-thumb-024&orientation=landscape',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    categoryColor: 'primary',
    duration: '6集',
    views: 4800000,
    rating: 9.5,
    publishDate: '2026-04-25',
    isHot: false,
    isNew: false,
    tags: ['工匠', '传统', '技艺', '文化'],
    detailContent: `<h2>影片简介</h2><p>《大国工匠：传承与创新》记录了12位中国顶尖工匠的故事，从景德镇瓷器大师到航天精密零件制造者，从苏绣传承人到芯片研发工程师，展现了"工匠精神"在不同领域的传承与创新。</p>`,
    relatedVideos: ['v016', 'v021', 'v023', 'v025'],
  },
  {
    id: 'v025',
    title: '宇宙时空之旅：未知领域',
    description: '跟随顶尖天文学家的脚步，探索宇宙中最神秘的未知领域，重新认识我们在宇宙中的位置。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20space%20cosmos%20scene%20with%20galaxies%20and%20nebulas%2C%20vibrant%20purple%20and%20blue%20cosmic%20colors%2C%20scientific%20visualization%20style%2C%20astronomy%20documentary%20poster&width=640&height=360&seq=video-thumb-025&orientation=landscape',
    categorySlug: 'jilupian',
    categoryName: '纪录片',
    categoryColor: 'primary',
    duration: '8集',
    views: 5700000,
    rating: 9.4,
    publishDate: '2026-03-20',
    isHot: false,
    isNew: false,
    tags: ['宇宙', '天文', '科学', '探索'],
    detailContent: `<h2>影片简介</h2><p>《宇宙时空之旅：未知领域》以最新的天文发现为基础，运用最先进的CGI技术，带领观众穿越可观测宇宙的边界，探索黑洞、暗物质、系外行星等最前沿的天文课题。</p>`,
    relatedVideos: ['v016', 'v021', 'v023', 'v024'],
  },
];

export const getVideoById = (id: string) => videos.find((v) => v.id === id);

export const getVideosByCategory = (categorySlug: string) =>
  videos.filter((v) => v.categorySlug === categorySlug);

export const getHotVideos = () => videos.filter((v) => v.isHot).slice(0, 8);

export const getNewVideos = () => videos.filter((v) => v.isNew).slice(0, 8);

export const getRelatedVideos = (video: Video) =>
  video.relatedVideos.map((id) => videos.find((v) => v.id === id)).filter(Boolean) as Video[];